import Vue from 'vue';
import { MdAvatar, MdCard, MdIcon } from 'vue-material/dist/components';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';

import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';

Vue.use(MdAvatar);
Vue.use(MdCard);
Vue.use(MdIcon);


Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
